module.exports = __webpack_public_path__ + "img/cpfl3.96b04c58.png";